<template>
  <div v-if="asyncDataStatus_ready">

    <v-row justify="space-between">
      <v-col cols="9" md="4">
        <AcceptanceFormsSearchForm
          @submit="search"
        />
      </v-col>
      <v-col cols="auto" style="display: flex; flex-direction: column;">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'MyCompanyAcceptanceFormsNew', params: { type: 0 }})"
        >
          Vnos
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          color="#0F998E"
          class="white--text mt-4"
          @click="$router.push({name: 'MyCompanyAcceptanceFormsNew', params: { type: 1 }})"
        >
          Hrana finančno
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
        <!-- <v-btn
          color="#0F998E"
          class="white--text mt-4"
          @click="$router.push({name: 'MyCompanyAcceptanceFormsNew'})"
        >
          Hrana finančno
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn> -->
        <v-btn
          color="#0F998E"
          class="white--text mt-4"
          @click="printListAcceptanceForms"
        >
        Tiskaj
        <v-icon right dark>mdi-printer</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-simple-table
          fixed-header
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th>
                  Št. prevzemnice
                </th>
                <th>
                  Interna št.
                </th>
                <th>
                  Dobavitelj
                </th>
                <th>
                  Datum
                </th>
                <th>
                  Vrednost
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="acceptanceForm in acceptanceForms"
                :key="acceptanceForm.id"
              >
                <td>{{acceptanceForm.delivery_document}}</td>
                <td>{{acceptanceForm.internal_label}}</td>
                <td>{{acceptanceForm.client_name}}</td>
                <td>{{acceptanceForm.date | sloDate}}</td>
                <td>{{acceptanceForm.total_amount_discounted | price}}</td>
                <td>
                  <ButtonActionEdit @click="$router.push({name: 'MyCompanyAcceptanceFormsEdit', params: {id: acceptanceForm.id}})" />
                  <ButtonActionPrint @click="printAcceptanceForm(acceptanceForm.id)" />
                  <ButtonActionDelete @click="showDeleteAcceptanceFormModal = true; deleteAcceptanceForm = acceptanceForm" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje prevzemnice"
      text="Ali ste prepričani, da želite izbrisati prevzemnico? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteAcceptanceFormModal"
      @confirmed="remove(deleteAcceptanceForm)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { objectToArray } from '@/utils/object'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ConfirmDialog from '@/components/ConfirmDialog'
import ButtonActionEdit from '@/components/ButtonActionEdit'
import ButtonActionDelete from '@/components/ButtonActionDelete'
import ButtonActionPrint from '@/components/ButtonActionPrint'
import AcceptanceFormsSearchForm from '@/components/AcceptanceFormsSearchForm'

export default {
  components: {
    ConfirmDialog,
    ButtonActionEdit,
    ButtonActionDelete,
    ButtonActionPrint,
    AcceptanceFormsSearchForm
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      acceptanceForms: [],
      showDeleteAcceptanceFormModal: false,
      deleteAcceptanceForm: null
    }
  },
  methods: {
    ...mapActions('acceptanceForms', ['loadItems', 'deleteItem', 'setFilters']),
    printAcceptanceForm (idacform) {
      let routeData = this.$router.resolve({ name: 'MyCompanyAcceptanceFormPreview', params: { id: idacform } })
      window.open(routeData.href, '_blank')
    },
    printListAcceptanceForms () {
      let routeData = this.$router.resolve({ name: 'MyCompanyAcceptanceFormsPreview', query: this.$store.state.acceptanceForms.filters })
      window.open(routeData.href, '_blank')
    },
    remove (item) {
      this.deleteItem(item.id)
        .then(() => {
          this.doLoadItems(this.$store.state.acceptanceForms.filters)
          /* this.$notify({
            type: 'success',
            text: 'Element uspešno izbrisan.'
          }) */
        })
    },
    search (form) {
      const filters = {}
      if (form.startDate) {
        filters.dateFrom = form.startDate
      }
      if (form.endDate) {
        filters.dateTo = form.endDate
      }
      if (form.clientName) {
        filters.clientName = form.clientName
      }
      if (form.deliveryDocument) {
        filters.deliveryDocument = form.deliveryDocument
      }
      this.setFilters(filters)
      this.doLoadItems(filters)
    },
    doLoadItems (filters) {
      this.loadItems({ filters })
        .then(res => {
          this.acceptanceForms = objectToArray(res)
        })
    },
    searchLastFilters () {
      const filters = this.$store.state.acceptanceForms.filters
      if (filters) {
        this.doLoadItems(filters)
      }
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({ type: 'error', text: 'Potrebna je vsaj ena aktivna poslovna enota' })
    } else {
      this.searchLastFilters()
      this.asyncDataStatus_fetched()
    }
  }
}
</script>
